import type React from "react";

import { useState } from "react";
import { CssClickableIcon, CssFlex, CssIcon } from "styles/helpers/layout";
import { StyledNotification } from "./Notification.styled";

import { type NotificationProps, getIconNameForNotificationType } from "./Notification.model";

export const Notification: React.FC<NotificationProps> = ({
  className,
  children,
  dataCy,
  type = "info",
  position,
}) => {
  const [isClosed, setIsClosed] = useState(false);

  return isClosed ? null : (
    <StyledNotification
      alignItems="start"
      className={className}
      data-cy={dataCy}
      gridTemplateColumns="auto 1fr auto"
      gap={1}
      $position={position}
      $variant={type}
    >
      <CssIcon iconName={getIconNameForNotificationType(type)} />
      <CssFlex alignItems="start" flexDirection="column" rowGap={1}>
        {children}
      </CssFlex>
      <CssClickableIcon
        data-cy={`${dataCy}-close-button`}
        iconName="fal fa-times"
        onClick={() => setIsClosed(true)}
      />
    </StyledNotification>
  );
};
